import { React, useEffect } from "react";
import { FooterNavigation, Header, PaginationHelper, TitleBar } from "webapp/components";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { AppState } from "webapp/enums/AppState";
import Modal from "react-responsive-modal";
import { ContractSelectionList } from "webapp/components/Partner/LDS/ContractSelectionList";
import ARIMemberInformationForm from "webapp/components/Partner/ARI/ARIMemberInformationForm/ARIMemberInformationForm";
import { ARIConfirmMileageExceededModal } from "webapp/components/Partner/ARI/ARIConfirmMileageExceededModal";
import { devLog } from "utils/devLog";
/**
 *
 * @param {
 * callBackFunc - callbackfunction that completes the submission of overall information
 * data - general data that populates the confirminfo value
 * confirmInfoDisab - legacy disablement update
 * confirmInfoDest - legacy destination update
 * backButtonFunc - original backbuttonfunc which regresses the app to confirm destination, or
 *
 * backButtonFunc2 -
 * } props
 * @returns
 */
export default function ARIMemberInformation(props) {
  const { t } = useTranslation();

  const [policyData, setPolicyData] = useState(null);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [selectionMade, setSelectionMade] = useState(false);
  const [isSelectionModalOpen, setIsSelectionModalOpen] = useState(false);
  const [deflectionFlag, setDeflectionFlag] = useState(false);
  const [showDeflectionModal, setShowDeflectionModal] = useState(false);
  const [showFooter, setShowFooter] = useState(false);

  const LocateUserObj = {
    img: props.logo,
    fragment: (
      <>
        <p className="mb-0">
          <strong>{t("ARI.PolicyInformation.TitleBar1")}</strong>
          <br />
          {/* <span className="alt-text-main">
            {t("description.PolicyInformationTitleBar2")}
          </span> */}
        </p>
      </>
    ),
  };

  const onUserCancel = (params) => {
    if (typeof props.onUserCancel === "function") {
      props.onUserCancel(params);
    }
  };

  const onUserNext = () => {
    devLog("onUserNext");

    if (!selectionMade) {
      setIsSelectionModalOpen(true);
      return;
    }

    if (deflectionFlag) {
      setShowDeflectionModal(true);
      return;
    }

    proceedToNextStep();
  };

  const proceedToNextStep = () => {
    devLog(selectedVehicle);
    if (selectedVehicle) {
      props.context.setState(
        {
          ContractNumber: selectedVehicle.contractNumber,
          Year: selectedVehicle.year,
          Make: selectedVehicle.make,
          Model: selectedVehicle.model,
          Color: selectedVehicle.color,
          VIN: selectedVehicle.vin,
          LicensePlate: selectedVehicle.licensePlate,
          ProvinceCode: selectedVehicle.licensePlateState,
          ClietId: selectedVehicle.clientId,
          UnitNo: selectedVehicle.unitNo,
          ServiceCardNum: selectedVehicle.serviceCardNum,
          allowVehicleInfoEdits: false,
          webAppState: AppState.ConfirmVehicle,
        },
        () => {
          props.context.saveWebAppState(props.context);
        },
      );
    } else {
      props.context.setState(
        {
          ContractNumber: null,
          Year: "",
          Make: "",
          Model: "",
          Color: "",
          VIN: "",
          Odometer: "",
          LicnesePlate: "",
          ProvinceCode: "",
          ClietId: "",
          UnitNo: "",
          ServiceCardNum: "",
          allowVehicleInfoEdits: true,
          webAppState: AppState.ConfirmVehicle,
        },
        () => {},
      );
    }
  };

  const onUserDeflection = () => {
    setShowDeflectionModal(false);
    props.context.setState(
      {
        deflectionOverride: false,
      },
      () => {
        if (typeof props.onUserCancel === "function") {
          props.onUserCancel({
            deflection: true,
            deflectionInfo: {
              contractData: policyData,
              selectedVehicle: selectedVehicle,
            },
          });
        }
      },
    );
  };

  const onUserSelectVehicle = (policy, vehicle, deflectionFlag) => {
    devLog("onUserSelectVehicle", policy, vehicle, deflectionFlag);
    devLog("isDisableDeflectionBypass", policy.isDisableDeflectionBypass);
    setPolicyData(policy);
    setSelectedVehicle(vehicle);
    setSelectionMade(typeof vehicle === "undefined" ? false : true);
    setDeflectionFlag(policy.isDisableDeflectionBypass);
  };

  const onContractLookupComplete = (success) => {
    setShowFooter(!!success);
  };

  return (
    <div className="CustCollectPage">
      <Header
        currState={props.currState}
        onUserBack={props.backButtonFunc}
        information={t("description.PolicyInformationHeader1")}
      />
      <TitleBar data={LocateUserObj} />
      <PaginationHelper context={props.context} />
      <ARIMemberInformationForm
        context={props.context}
        currState={props.currState}
        onSelect={onUserSelectVehicle}
        onUserBack={props.backButtonFunc}
        onUserCancel={onUserCancel}
        onLoad={onContractLookupComplete}
      />
      <Modal
        className={`policy-loader-modal`}
        open={isSelectionModalOpen}
        onClose={() => {
          setIsSelectionModalOpen(false);
        }}
      >
        <h2 style={{ marginTop: 30 }}>{t("description.PolicyInformationHeader1")}</h2>
        <div>{t("description.PolicyInformationPleaseMakeSelection")}</div>
      </Modal>
      <ARIConfirmMileageExceededModal
        isOpen={showDeflectionModal}
        logo={props.currState.localGroupLogo}
        onYes={onUserDeflection}
        isDisableDeflectionBypass={deflectionFlag}
      />
      {showFooter ? <FooterNavigation onCancelClick={onUserCancel} onNextClick={onUserNext} /> : <></>}
    </div>
  );
}
